export default function TarifsSection({ googleFormLink }) {
  return (
    <section id="tarifs" className="section alt">
      <div className="container">
        <span className="section-label">💰 Adhésion</span>
        <h2 className="section-title">Tarifs</h2>
        <p className="section-sub">Transparent et sans surprise — tout est inclus dès le départ.</p>

        <div className="pricing-grid">

          <div className="price-card highlight">
            <div className="price-badge">Essentiel</div>
            <div className="price-head">
              <h3>Cotisation annuelle</h3>
              <div className="price">300€</div>
              <div className="per">par an</div>
            </div>

            <ul>
              <li>Accès à tous les cours</li>
              <li>Tous niveaux acceptés</li>
              <li>Encadrement diplômé Adeps</li>
              <li>3 séances par semaine</li>
            </ul>
          </div>

          <div className="price-card">
            <div className="price-head">
              <h3>Licence & Assurance</h3>
              <div className="price">47€</div>
              <div className="per">par an</div>
            </div>

            <ul>
              <li>Obligatoire pour pratiquer</li>
              <li>Couverture assurance complète</li>
              <li>Licence officielle JWB</li>
            </ul>
          </div>

          <div className="price-card free">
            <div className="price-head">
              <h3>Premier cours</h3>
              <div className="price">Offert</div>
            </div>

            <p className="free-text">
              Venez essayer sans engagement.<br />
              Aucun équipement requis pour débuter.
            </p>

            <a
              href={googleFormLink}
              target="_blank"
              rel="noreferrer"
              className="btn-primary"
            >
              Je m’inscris
            </a>
          </div>

        </div>

        <p className="tarifs-total">
          Total annuel : <strong>347€</strong> (cotisation + licence) · Paiement en plusieurs fois possible — contactez-nous.
        </p>
      </div>
    </section>
  );
}
